import React, { useContext, useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';

import ErrorBoundary from 'app/lib/ErrorBoundary';
import { setFirstSeenAt } from 'app/shared/utils/firstSeenAt';
import { UPDATE_SESSION } from 'app/shared/graphql/sessions/mutations';
import { AuthContext } from 'app/shared/context/Auth';
import { Breadcrumb } from 'app/shared/components/molecules';
import { NavbarProps } from 'app/shared/components/organisms/Navbar';
import { MainLayoutTemplate } from 'app/shared/components/templates';
import { GlobalError } from 'app/shared/components/pages/Status';

interface Props {
  children: any;
  navbarProps?: NavbarProps;
  breadcrumbProps?: Breadcrumb[];
  'data-qaid'?: string;
  renderAboveNavComponent?: () => void;
  useMinimalFooter?: boolean;
  backgroundColor?: string;
  isLandingPage?: boolean;
}

const MainCommonThemeLayout = (props: Props) => {
  const authContext = useContext(AuthContext);
  const [displayBannerMessage, setDisplayBannerMessage] = useState(true);
  const [updateSession] = useMutation(UPDATE_SESSION);
  const authContextFinishedLoading = authContext && !authContext.loading;

  useEffect(() => {
    if (authContextFinishedLoading) {
      setFirstSeenAt(authContext);
    }
  }, [authContextFinishedLoading, authContext]);

  function handleBannerDismiss() {
    setDisplayBannerMessage(false);
    updateSession({
      variables: {
        hideBannerMessage: true,
      },
    });
  }

  return (
    <MainLayoutTemplate
      {...props}
      authContextFinishedLoading={authContextFinishedLoading}
      bannerMessage={authContext?.sessionMessage}
      displayBannerMessage={displayBannerMessage}
      handleBannerDismiss={handleBannerDismiss}
    />
  );
};

const GlobalErrorComponent = () => {
  return <GlobalError noLayout={true} />;
};

export default (props: Props) => {
  return (
    <ErrorBoundary ErrorComponent={GlobalErrorComponent}>
      <MainCommonThemeLayout {...props} />
    </ErrorBoundary>
  );
};
